export interface IIntegrationChannel {
  id: number
  platform: 'slack' | 'teams'
  name: string
  webhookUrl: string
  events: string[]
  enabled: boolean
  createdBy?: string
  createdAt?: string
  updatedAt?: string
}

export const PLATFORM_OPTIONS: Record<string, string> = {
  slack: 'Slack',
  teams: 'Microsoft Teams',
}

/**
 * The internal events a channel can subscribe to. Keys must match the backend
 * IntegrationEventType enum values exactly, since they are persisted verbatim.
 */
export const EVENT_OPTIONS: Record<string, string> = {
  'loan.status.changed': 'Loan status changed',
  'loan.servicingStatus.changed': 'Servicing status changed',
  'task.createPortalTask': 'Task created',
  'note.mentioned': 'Note mention',
}
